// src/components/Footer.jsx
import React from 'react';

const Footer = () => (
  <footer
    className="bg-white text-black py-8"
    style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}
  >
    <div className="container mx-auto px-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center md:text-left">
        <p
          className="text-sm"
          style={{
            fontFamily: 'Montserrat, sans-serif',
            maxWidth: '250px',
            margin: '0 auto',
          }}
        >
          Email: <a href="mailto:info@rubixc.com" className="text-blue-500 hover:underline">info@rubixc.com</a>
        </p>
        <p
          className="text-sm"
          style={{
            fontFamily: 'Montserrat, sans-serif',
            maxWidth: '250px',
            margin: '0 auto',
          }}
        >
          Address: 4103 N Southport Ave, Chicago, IL 60613
        </p>
        <p
          className="text-sm"
          style={{
            fontFamily: 'Montserrat, sans-serif',
            maxWidth: '250px',
            margin: '0 auto',
          }}
        >
          Phone: <a href="tel:+13126025411" className="text-blue-500 hover:underline">(312) 602 5411</a>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
